import {
    GET_USERS,
    USERS_ERROR,
    PUT_USERS,
    SET_CLICKED_USER,
    SET_USER_STATUS,
    GET_SESSION,
    SESSION_READY,
} from '../ActionTypes';

const initialState = {
    users: [],
    session: '',
    sessionReady: false,
    clickedUser: '',
    loading: true,
    error: '',
};

const userReduction = (state = initialState, action) => {
    switch (action.type) {
        case GET_USERS:
            return {
                ...state,
                users: action.payload,
                loading: false,
                error: '',
            };
        case PUT_USERS:
            return {
                ...state,
                users: action.payload,
                loading: false,
                error: '',
            };
        case SET_CLICKED_USER:
            return {
                ...state,
                clickedUser: action.payload,
                loading: false,
                error: '',
            };
        case SET_USER_STATUS:
            return {
                ...state,
                clickedUser: action.payload,
                loading: false,
                error: '',
            };
        case GET_SESSION:
            return {
                ...state,
                session: action.payload,
            };
        case SESSION_READY:
            return {
                ...state,
                sessionReady: action.payload,
            };
        case USERS_ERROR:
            return {
                ...state,
                users: [],
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default userReduction;
